<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditWhiteListEntryDialog(true)"
      >新增白名单项</el-button
    >

    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      size="mini"
      style="margin-top: 30px"
    >
      <el-form-item label="UID：">
        <el-input v-model="form.uid" clearable style="width: 172px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onClickQueryBtn()"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="whiteListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="whiteListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 410px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="160">
      </el-table-column>
      <el-table-column prop="uid" label="UID" align="center" width="100">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="onClickDeleteWhiteListBtn(scope.row.uid)"
            >删除</el-button
          >
          <el-button
            round
            size="mini"
            @click="onClickViewLogsBtn(scope.row.uid)"
            >日志</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改白名单项”对话框 -->
    <EditWhiteListEntryDialog
      v-if="shouldEditWhiteListEntryDialogVisible"
      @close="onEditWhiteListEntryDialogClosed()"
      :value="valueForEditWhiteListEntryDialog"
    ></EditWhiteListEntryDialog>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("../../util");

import EditWhiteListEntryDialog from "./EditWhiteListEntryDialog";

export default {
  data() {
    return {
      shouldEditWhiteListEntryDialogVisible: false, // “添加/修改白名单项”对话框是否应该显示出来
      valueForEditWhiteListEntryDialog: null, // 要传递给“添加/修改白名单项”对话框的数据
      whiteListTableData: [], // 白名单列表里展示的数据
      form: {
        uid: "",
      },
    };
  },

  async created() {
    // 自动拉白名单
    await this.loadWhiteList();
  },

  components: {
    EditWhiteListEntryDialog,
  },

  methods: {
    loadMore() {},

    /**
     * 点击了白名单项的删除按钮
     * @param {*} uid
     */
    onClickDeleteWhiteListBtn(uid) {
      this.$confirm("此操作将删除该白名单项，是否继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteWhiteListEntry(uid);

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    /**
     * 点击了查看日志按钮
     */
    onClickViewLogsBtn(uid) {
      // 挑战到查询日志页面
      this.$router.push({
        path: "/console/misc/clientlog",
        query: { uid: uid },
      });
    },

    /**
     * 查询白名单
     * @param {*} uid 大于0表示根据uid查询，否则表示查询所有
     */
    async loadWhiteList(uid) {
      if (uid > 0) {
        // 根据uid查

        // 先清空原有记录
        this.whiteListTableData = [];

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/getWhiteListByUid`,
            {
              uid: uid,
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        let listInResp = resData.data.whiteList || [];

        let list = [];
        for (let e of listInResp) {
          list.push({
            uid: parseInt(e.uid),
            when: moment(parseInt(e.createTime)).format("yyyy-MM-DD HH:mm:ss"),
          });
        }

        this.whiteListTableData = this.whiteListTableData.concat(list);
      } else {
        // 查所有

        // 先清空原有记录
        this.whiteListTableData = [];

        let resData = (
          await axios.get(`${util.getBackendApiBase()}/v1/getWhiteList`, {
            headers: {
              token: util.getLoginUserToken(),
            },
          })
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        let listInResp = resData.data.whiteList || [];

        let list = [];
        for (let e of listInResp) {
          list.push({
            uid: parseInt(e.uid),
            when: moment(parseInt(e.createTime)).format("yyyy-MM-DD HH:mm:ss"),
          });
        }

        this.whiteListTableData = this.whiteListTableData.concat(list);
      }
    },

    /**
     * 删除一个白名单项
     */
    async deleteWhiteListEntry(uid) {
      let requestBody = {
        uidList: [
          {
            uid: uid.toString(),
          },
        ],
      };

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/delCheckWhiteList`,
          requestBody,
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 重新拉白名单
      return this.loadWhiteList();
    },

    /**
     * 打开“添加/修改白名单项”对话框
     */
    async openEditWhiteListEntryDialog(isCreate, oldData) {
      this.shouldEditWhiteListEntryDialogVisible = true;
      this.valueForEditWhiteListEntryDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改白名单项”对话框关闭了
     */
    async onEditWhiteListEntryDialogClosed() {
      this.shouldEditWhiteListEntryDialogVisible = false;
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      if (this.form.uid.trim() == "") {
        await this.loadWhiteList();
      } else {
        let uid = parseInt(this.form.uid);
        if (isNaN(uid) || uid <= 0) {
          this.$message({
            message: "请填入正确的UID",
            type: "error",
          });
          return;
        }

        await this.loadWhiteList(uid);
      }
    },
  },
};
</script>